// Module-scope image decode cache.
//
// Problem this solves: Chrome's decoded-bitmap cache is ephemeral. When a card
// scrolls off-viewport and the page creates pressure, the decoded pixels get
// purged. On scroll-back, Chrome paints a placeholder while re-decoding — this
// is the visible "flash/print" effect. By holding a strong reference to an
// Image object whose decode() has resolved, we keep the decoded bitmap in
// memory and skip the re-decode.
//
// Pattern used by Google Photos, Instagram web, and the pattern the
// HTMLImageElement.decode() API was added to the spec to enable.

const MAX_CACHE_SIZE = 200;
const cache = new Map();

export const preDecode = (url) => {
  if (!url || typeof window === "undefined") return Promise.resolve(null);
  if (cache.has(url)) {
    // Move to end for LRU-ish ordering.
    const p = cache.get(url);
    cache.delete(url);
    cache.set(url, p);
    return p;
  }

  const img = new Image();
  img.decoding = "async";
  img.src = url;
  const p = img.decode().then(() => img).catch(() => img);

  cache.set(url, p);
  if (cache.size > MAX_CACHE_SIZE) {
    const oldest = cache.keys().next().value;
    cache.delete(oldest);
  }
  return p;
};

export const preDecodeMany = (urls) => {
  if (!urls?.length) return;
  urls.forEach((u) => {
    if (u) preDecode(u);
  });
};
